module.exports = __webpack_public_path__ + "static/awareness_tablet-62e507db05c179364a6c07caccbeeb98.png";